import { IAppState } from "../models/IAppState"
import {WhatsAppPatientInfo} from "../components/WhatsAppChatComponent";

let initialState: IAppState = {
    locked: true,
    accountData: null,
    doctorProfile: null,
    treatmentPlanReducer: null,
    responseData: {
        showModal: false,
        formattedConfigAvailable: false
    },

    generalExaminationList: null,
    appointments: null,
    allAppointments: null,
    consultations: {
        scheduledConsultations: null,
        upcomingConsultations: null
    },
    patientAppointments: null,
    patientCompleteInfo: {
        profile: null,
        vitals: null,
        consultations: null,
        labTests: null,
        allergies: null,
        currentMedication: null,
        habits: null,
        surgeryAndProcedure: null,
        comorbidCondition: null,
        conditions: null,
        concerns: null,
        redFlags: null,
        generalExaminations: null,
        systemicExaminations: null,
        personalInfo: null,
        typeFormData: null,
        adherenceData: null,
        activityDishesMap: {},
        patientPlan: null,
        patientGoals: null,
        patientMetrics: null,
        adherenceScores: {}
    },
    covidInfo: {
        isCovidActivePack: false
    },
    userform: {},
    chatAndVideoAccessTokens: {
        chatAccessToken: null,
        videoAccessToken: null
    },
    allStaticDataNew: {
        vitalList: null,
        habitList: null,
        doctorSpecialityResponseList: null,
        medicalTypeList: null,
        staticDietRecallData: null,
        foodGroups: null,
        trackableSymptoms: [],
        goals: [],
        metrics: [],
        generalExaminations: null,
        systemicExaminations: null,
        entExaminations: null,
        mentalStatusExaminations: null,
        reviewOfSystems: null,
        redFlags: null,
        pastConditions: null,
        diagnostics: null,
        surgery: null,
        allergy: null,
        lifeStyleProfile: null,
        mindfulnessInformation: null,
        fitnessRecallInformation: null,
        routineActivities: null,
        personalInformation: null,
        personalInformationPhysiotherapist: null,
        lifestylePlanHabits: null,
        habits: null,
        allPreferredFoodTypes: null,
        allPreferredCuisines: null,
        typeFormMapping: [
            { code: "H5nhEER1rA4x", group: "PERSONAL_INFORMATION" },
            { code: "VrLjzJTQEQH8", group: "PERSONAL_INFORMATION" },
            { code: "jNxMzXfckdu1", group: "ALLERGIES" },
            { code: "T0rFHPtjOrFD", group: "PERSONAL_INFORMATION" },
            { code: "jJ6ePDOh8m1P", group: "PERSONAL_INFORMATION" },
            { code: "b8A9m4wo1rLU", group: "SURGERIES" },
            { code: "kE2s5QDld0eo", group: "PERSONAL_INFORMATION" },
            { code: "zu4oTx1ghtrv", group: "VITALS" },
            { code: "rAnjlPSYGTTN", group: "PERSONAL_INFORMATION" },
            { code: "VllQxUZjb50i", group: "PERSONAL_INFORMATION" },
            { code: "dl9Iu7x76U4m", group: "PERSONAL_INFORMATION" },
            { code: "yrCcCzw7cvWa", group: "WORRIES" },
            { code: "BW4YIgC9DTRX", group: "AGE" },
            { code: "jakdjWdapoPR", group: "PERSONAL_INFORMATION" },
            { code: "gRZaEdrUwHvX", group: "MEDICAL_CONDITIONS" },
            { code: "FIZNgtGJnmEN", group: "VITALS" },
            { code: "hKLHrCYq3AlS", group: "PERSONAL_INFORMATION" },
            { code: "BddYqfTx34N7", group: "PERSONAL_INFORMATION" },
            { code: "K0mHeI8FHzNb", group: "PERSONAL_INFORMATION" },
            { code: "efzqO8x87GYz", group: "FAMILY_CONDITIONS" }
        ]
    },
    ongoingConsultation: {},
    editPrescription: {},
    centerInfo: {
        center: null,
        rooms: null,
        doctors: null,
        appointments: null
    },
    mpPatientsData: [],
    twilioContext: {
        userIdentity: null,
        accessToken: null,
        channelInfo: null,
        totalUnreadCount: null,
        currentChannel: {
            channelSid: null,
            channel: null
        },
        channelsSynced: false,
        connectionStrengthMessage: "",
        clients: {}
    },
    whatsAppChatContext: {
        patientInfo: null,
        chatWindowVisible: false,
    },
    overrides: {
    },
    featureConfigInfo: {},
    fitnessData: {
        exercises: null,
        userFitnessPlan: null,
        userFitnessPlanStartDate: null,
        isPublishedPlan: false
    }
};

export default initialState;





